import { Component, OnInit } from '@angular/core';
import { ActualitesComponent} from '../actualites/actualites.component';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HTTPClientService } from '../../shared/services/httpclient.service';
import { TranslateService} from '@ngx-translate/core';


import { UtilsService } from '../../shared/services/utils.service';
import { Validators } from '@angular/forms';
import { NewsService } from '../../shared/services/news.service';
import { DatePipe } from '@angular/common';
import { LanguageService } from '../../shared/services/language.service';
import { JobsService } from '../../shared/services/jobs.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.css']
})
export class JobsComponent extends ActualitesComponent implements OnInit  {

  public allJobs:any = [];

  constructor(
      protected _sanitizer: DomSanitizer,
      public newsService: NewsService,
      protected activatedRoute: ActivatedRoute,
      public utilsService : UtilsService,
      public language : LanguageService,
      public translate:TranslateService,
      public JobsService:JobsService
  ) {
      super(_sanitizer,newsService,activatedRoute,language);
  }

  ngOnInit() {
      this.refreshJobs()
  }

  refreshJobs(){
      this.JobsService.getJobs()
      .then((res)=>{
          this.allJobs = res
      })
  }

  formateJobLink(id, name){
      var link = id+"-"+name
      link = link.replace(/[^a-zA-Z0-9-_çïëüâêîôûèàùé ]/g, '')
      link = link.replace(/[\s]{2,}/g," "); // Enlève les espaces doubles, triples, etc.
      link = link.replace(/^[\s]/, ""); // Enlève les espaces au début
      link = link.replace(/[\s]$/,""); // Enlève les espaces à la fin
      link = link.replace(/ /g, '-')

      if(this.language.langs.indexOf(this.translate.store.currentLang)>0){
          link+='-'+this.translate.store.currentLang
      }
      return link
  }

  removeHtmlTags(str=""){
      return str.replace(/<[^>]*>/g, '')
  }

}
